<template>
  <v-card
    :elevation="elevation"
    @click="qunit_clicked"
    class="qmkey-card"
    :class="[isSelected ? 'selected_card' : '', is_mobile ? 'is-mobile':'']"
  >
      <!-- HEADER -->
      <v-card-title class="qmkey-card-title" :class="is_mobile ? 'is-mobile':''">
        <div class="qmkey-title-fields">
          <div>
            <Field
              short
              class="d-inline-block"
              :field="unit.fields['reference']"
              :navigate="canNavigate ? unit.navigate_list.includes('reference') : false"
              :is_mobile="is_mobile"
              @download-evidence="download_file"
              @navigate_to="navigate_to"
            />
          </div>
          <v-spacer class="spacer-min-space"></v-spacer>
          <div class="overflow-hidden">
            <Field
              short
              :field="unit.fields['title']"
              :navigate="canNavigate ? unit.navigate_list.includes('title') : false"
              :is_mobile="is_mobile"
              @download-evidence="download_file"
              @navigate_to="navigate_to"
            />
          </div>
        </div>
      </v-card-title>

      <!-- BODY -->
      <v-card-text>
        <v-row v-for="row in cols" :key="'mobile' + row.map((f) => f.id).join('|')">
          <v-col v-for="col in row" :key="'mobile' + col.id || 'mobile_error'" class="no-padding-height">
            <div class="d-flex qmkey-card-body" :class="is_mobile ? 'is-mobile':''">
              <span 
                v-if="col && colText(col)" 
                class="font-weight-bold pr-auto"
              >
                {{ colText(col) }}
              </span>
              <Field
                v-if="col && col.value"
                short
                :field="unit.fields[col.value]"
                :navigate="canNavigate ? unit.navigate_list.includes(col.value) : false"
                :is_mobile="is_mobile"
                @download-evidence="download_file"
                @navigate_to="qunit_clicked"
              />
            </div>
            <v-spacer class="spacer-min-space"></v-spacer>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- ACTIONS -->
      <v-card-actions :class=" center_actions ? 'qmkey-card-actions-centered' : 'qmkey-card-actions'" v-if="actions">
        <span
          :class="center_actions ? 'items-center-position' : 'items-end-position'"
        >
          <Actions
            size="medium"
            :unit="unit"
            :action_list="action_list"
            @clicked="action_clicked"
            @update-qunit="update_qunit"
            @click.stop
            @mousedown.stop
            @mouseup.stop
          />
        </span>
      </v-card-actions>
    </v-card>
</template>


<style lang="scss">
 @import '@/sass/explorer.scss';
 .qmkey-card {
  background-color: white;
  width: 100%;
  .is-mobile {
    font-size: x-small;
  }
 }
 .qmkey-card-title {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
 }
 .qmkey-title-fields {
  display: inline-flex;
  text-wrap: nowrap;
  width: 100%;
  .is-mobile {
    font-size: small;
  }
 }
 .qmkey-card-body {
  padding-bottom: 0px;
  padding-top: 0px;
  flex-wrap: wrap;
  .is-mobile {
    font-size: x-small;
  }
 }
 .qmkey-card-actions {
  justify-content: end;
 }
 .qmkey-card-actions-centered {
  justify-content: center;
 }
 .items-center-position {
  align-items: center;
 }
 .items-end-position {
  align-items: end;
 }
 .no-padding-height {
  padding-bottom: 0px !important; padding-top: 0px !important;
 }
 .spacer-min-space {
  min-width: 0.5em;
 }
 .selected_card {
  background-color: #DDDDDD !important;
 }
</style>


<script>
 import { QFilters } from '@/qunit/filters';
 import Field from '@/components/qfields/Field';
 import Actions from '@/components/explorer/actions/Actions';
 import { downloadFile } from '@/utils/browserfiles';
 import QUnitAPI from '@/api/QUnit'
 import { mapState } from 'vuex';

 export default {
   name: 'ExplorerCard',

   components: {
     Field,
     Actions,
   },

   props: {
     unit: {required: true},
     columns: {},
     actions: {type: Boolean, default: false},
     action_list: {default: () => ([])},
     center_actions: {type: Boolean, default: false},
     disabled: {type: Boolean, default: false},
     navigate: {type: Boolean, default: false},
     elevation: {default: 2},
     isSelected: {type: Boolean, default: false},
     is_mobile: {type: Boolean, defalut: false},
   },

   data: () => ({
    header_col: ['reference', 'title'],
    default_columns: [
      [{"id":0,"value":"fecha_creacion","text":"Fecha creación","cols":1},
      {"id":1,"value":"current_workflow_state","text":"Estado","cols":1}],
      [{"id":2,"value":"current_workflow_responsible","text":"Pŕoxima Acción","cols":1},
      {"id":3,"value":"current_workflow_limit","text":"Fecha limite","cols":1}],
      [{"id":4,"value":"fecha_cierre","text":"Fecha cierre","cols":1}]
    ],
   }),

   computed: {
    ...mapState(['bpmap',]),
     cols() {
          // If has columns params
       return this.columns
          // If qunit has card layout
          || this.bpmap._bps[this.unit.business_process].card_layout
          // Show table headers,
          //TODO: array of arrays, rows and cols
          || (this.bpmap._bps[this.unit.business_process].columns ? 
              this.bpmap._bps[this.unit.business_process].columns.filter(col => col.value == 'action') :
              this.default_columns);
     },
     canNavigate() {
      return this.navigate && this.unit.navigate_list;
     },
     action_col() {
        return this.cols.filter(col => !this.actions || col.value == 'action');
      },
      content() {
        return this.cols.filter(col => !this.header_col.some(h_col => h_col === col.value) && !this.action_col.some(a_col => a_col.value === col.value));
      },
      content_row() {
        let result = [];
        let i = 0;
        while(i < this.content.length) {
          let item = [];
          item.push(this.content[i]);
          if(i+1 <= this.content.length) {
            item.push(this.content[i+1]);
          } else {
            item.push({});
          }
          result.push(item);
          i = i + 2;
        }
        return result;
      },
   },

   methods: {
    colText(col) {
      return ((this.unit[col.value] || {}).props || {}).label;
        // if (col.text){
        //   return col.text + ': ';
        // } else {
        //   return '';
        // }
      },
     update_row(filters) {
       this.$emit('update', filters || new QFilters());
     },

     update_qunit(new_qunit) {
       this.$emit('update-qunit', new_qunit);
     },

     navigate_to() {
      this.$emit('navigate_to');
     },

     action_clicked() {
      this.$emit('action-click');
     },

     qunit_clicked() {
       if (! this.disabled)
         this.$emit('click');
     },

     async download_file(qunit_file_value) {
       const row = qunit_file_value
         ? qunit_file_value.props
         : this.unit.current_state_document;
       const title = row.downloable_title || row.title

       try {
         const data = QUnitAPI
           .getQUnitFile(
             this.unit._protected.centro,
             row.qunit_id,
             row.attribute,
             row.value,
             row.version,
             row.title,
           );
         downloadFile(data, title);
         if (row.version) {
           this.update_qunit_after();
         }

       } catch (err) {
         console.error('handle_evidence', err);
       }
     },

    async update_qunit_after() {
      const updated_data = await QUnitAPI.getQUnit(this.unit._protected.centro, this.unit.uid);
      let new_qunit = new QUnit(updated_data);
      this.$emit('update-qunit-at', new_qunit);
     },
   },
 }
</script>
